module.exports = __webpack_public_path__ + "img/PB_Afrika nap_097-2~2.694bf142.jpeg";